"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var binding_when_syntax_1 = require("./binding_when_syntax");
var BindingOnSyntax = (function () {
    function BindingOnSyntax(binding) {
        this._binding = binding;
    }
    BindingOnSyntax.prototype.onActivation = function (handler) {
        this._binding.onActivation = handler;
        return new binding_when_syntax_1.BindingWhenSyntax(this._binding);
    };
    return BindingOnSyntax;
}());
exports.BindingOnSyntax = BindingOnSyntax;



//////////////////
// WEBPACK FOOTER
// ./node_modules/inversify/lib/syntax/binding_on_syntax.js
// module id = xk4U
// module chunks = 0